import { InjectionToken, Directive, ElementRef, Inject, Input, Optional, ChangeDetectionStrategy, Component, ViewChild, ViewEncapsulation, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @abstract
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';

const _c0 = ["editor"];
class EditorBase {
    /**
     * @param {?} editorControl
     * @param {?} _config
     */
    constructor(editorControl, _config) {
        this.editorControl = editorControl;
        this._config = _config;
        this.propagateChange = (_) => {
        };
        this.propagateTouched = () => {
        };
        editorControl.valueAccessor = this;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        const /** @type {?} */ control = this.editorControl.control;
        control.setValidators(control.validator);
        control.updateValueAndValidity();
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        $(this._editor.nativeElement).trumbowyg(Object.assign({}, this._config, this.options)).on('tbwinit', () => {
            $(this._editor.nativeElement).trumbowyg(this._disabled ? 'disable' : 'enable');
            this.setContent(this._initValue);
        }).on('tbwchange', () => {
            this.propagateChange(this.getContent());
        }).on('tbwblur', () => {
            this.propagateTouched();
        });
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        this._initValue = value;
        if (this._editor && this._editor.nativeElement) {
            this.setContent(value);
        }
    }
    /**
     * @param {?} disabled
     * @return {?}
     */
    setDisabledState(disabled) {
        this._disabled = disabled;
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        $(this._editor.nativeElement).trumbowyg('destroy');
    }
    /**
     * @param {?} content
     * @return {?}
     */
    setContent(content) {
        $(this._editor.nativeElement).trumbowyg('html', content);
    }
    /**
     * @return {?}
     */
    getContent() {
        return $(this._editor.nativeElement).trumbowyg('html');
    }
}
EditorBase.ɵfac = function EditorBase_Factory(t) { ɵngcc0.ɵɵinvalidFactory(); };
EditorBase.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorBase });


/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const TRUMBOWYG_OPTIONS = new InjectionToken('Trumbowyg options');

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EditorDirective extends EditorBase {
    /**
     * @param {?} editorControl
     * @param {?} _config
     * @param {?} _editor
     */
    constructor(editorControl, _config, _editor) {
        super(editorControl, _config);
        this.editorControl = editorControl;
        this._config = _config;
        this._editor = _editor;
    }
}
EditorDirective.ɵfac = function EditorDirective_Factory(t) { return new (t || EditorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl), ɵngcc0.ɵɵdirectiveInject(TRUMBOWYG_OPTIONS, 8), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
EditorDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: EditorDirective, selectors: [["", "trumbowygNgxEditor", ""]], inputs: { options: "options", placeholder: "placeholder" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature] });
/** @nocollapse */
EditorDirective.ctorParameters = () => [
    { type: NgControl, },
    { type: undefined, decorators: [{ type: Inject, args: [TRUMBOWYG_OPTIONS,] }, { type: Optional },] },
    { type: ElementRef, },
];
EditorDirective.propDecorators = {
    "options": [{ type: Input },],
    "placeholder": [{ type: Input },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorDirective, [{
        type: Directive,
        args: [{
                selector: '[trumbowygNgxEditor]'
            }]
    }], function () { return [{ type: ɵngcc1.NgControl }, { type: undefined, decorators: [{
                type: Inject,
                args: [TRUMBOWYG_OPTIONS]
            }, {
                type: Optional
            }] }, { type: ɵngcc0.ElementRef }]; }, { options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class EditorComponent extends EditorBase {
    /**
     * @param {?} editorControl
     * @param {?} _config
     */
    constructor(editorControl, _config) {
        super(editorControl, _config);
        this.editorControl = editorControl;
        this._config = _config;
    }
}
EditorComponent.ɵfac = function EditorComponent_Factory(t) { return new (t || EditorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc1.NgControl), ɵngcc0.ɵɵdirectiveInject(TRUMBOWYG_OPTIONS, 8)); };
EditorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: EditorComponent, selectors: [["trumbowyg-ngx-editor"]], viewQuery: function EditorComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx._editor = _t.first);
    } }, inputs: { options: "options", placeholder: "placeholder" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 2, vars: 1, consts: [[3, "placeholder"], ["editor", ""]], template: function EditorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "textarea", 0, 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("placeholder", ctx.placeholder ? ctx.placeholder : "");
    } }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
EditorComponent.ctorParameters = () => [
    { type: NgControl, },
    { type: undefined, decorators: [{ type: Inject, args: [TRUMBOWYG_OPTIONS,] }, { type: Optional },] },
];
EditorComponent.propDecorators = {
    "options": [{ type: Input },],
    "placeholder": [{ type: Input },],
    "_editor": [{ type: ViewChild, args: ['editor',] },],
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(EditorComponent, [{
        type: Component,
        args: [{ selector: 'trumbowyg-ngx-editor', template: `<textarea #editor [placeholder]="placeholder ? placeholder : ''"></textarea>
`, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None }]
    }], function () { return [{ type: ɵngcc1.NgControl }, { type: undefined, decorators: [{
                type: Inject,
                args: [TRUMBOWYG_OPTIONS]
            }, {
                type: Optional
            }] }]; }, { options: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], _editor: [{
            type: ViewChild,
            args: ['editor']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class TrumbowygNgxModule {
    /**
     * @param {?} options
     * @return {?}
     */
    static withConfig(options) {
        return {
            ngModule: TrumbowygNgxModule,
            providers: [{ provide: TRUMBOWYG_OPTIONS, useValue: options }]
        };
    }
}
TrumbowygNgxModule.ɵfac = function TrumbowygNgxModule_Factory(t) { return new (t || TrumbowygNgxModule)(); };
TrumbowygNgxModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TrumbowygNgxModule });
TrumbowygNgxModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({});
/** @nocollapse */
TrumbowygNgxModule.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrumbowygNgxModule, [{
        type: NgModule,
        args: [{
                declarations: [EditorComponent, EditorDirective],
                exports: [EditorComponent, EditorDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TrumbowygNgxModule, { declarations: [EditorComponent, EditorDirective], exports: [EditorComponent, EditorDirective] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */

export { TrumbowygNgxModule, EditorComponent as ɵa, TRUMBOWYG_OPTIONS as ɵd, EditorDirective as ɵe, EditorBase as ɵb };

